import { render, staticRenderFns } from "./ProductivityByMonthsTasksAndRequestsList.vue?vue&type=template&id=073a7fe0&scoped=true&"
import script from "./ProductivityByMonthsTasksAndRequestsList.vue?vue&type=script&lang=js&"
export * from "./ProductivityByMonthsTasksAndRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a7fe0",
  null
  
)

export default component.exports